export default __webpack_public_path__ + "static/media/ms_tickets_icon.99866bcf.svg";